exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".application-information .info_header .chevron{visibility:hidden}.application-information h2{word-spacing:2.5px}.remove-border-radius{border-radius:0}.application-information .info_body .colorcont .left p{opacity:1;color:#000;font-family:Lato,sans-serif;font-weight:300;font-size:18px}.application-information .info_body .colorcont .right p{color:#000;font-family:Lato,sans-serif;font-weight:700;font-size:16px}.application-information .info_body .colorcont{background:#e5e5e5}.application-information .info_body .white{background:#fff}@media (max-width:768px){.remove-padding{padding:0}.application-information .info_header .chevron{visibility:visible;transition:all .3s cubic-bezier(.34,.51,.15,1)}.application-information .applicant_body.active,.application-information .employment_body.active{visibility:hidden;opacity:0;height:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/view/application/application.css
// module id = 917
// module chunks = 0